import Map from '@components/Features/Map';
import Quiz from '@components/Features/Quiz';
import Poll from '@components/Features/Poll';
import Wordcloud from '@components/Features/Wordcloud';
import TextTrack from '@components/Features/TextTrack';
import Leaderboard from '@components/Features/Leaderboard';
import LinkLibrary from '@components/Features/LinkLibrary';
import RatingPolls from '@components/Features/RatingPolls';
import TalkingTiles from '@components/Features/TalkingTiles';
import FantasticFans from '@components/Features/FantasticFans';
import Credits from '@components/Features/Credits/Credits';
import Presentations from '@components/Features/Presentations';
import QuickQuestions from '@components/Features/QuickQuestions';
import MultipleChoice from '@components/Features/MultipleChoice';
import TransientThought from '@components/Features/TransientThought';
import EmojisEverywhere from '@components/Features/EmojisEverywhere';
import WinnerWheel from '@components/Features/WinnerWheel/WinnerWheel';

import { Modal } from '@atoms/new/modal';
import TrackInteractionsModal from '@components/Layout/TrackInteractionsModal';

import InteractionErrorBoundary from '@components/Errors/InteractionErrorBoundary';

export const getOnFeature = (props) => {
  const interactionComponent = {
    wheel: <WinnerWheel {...props} />,
    newWheel: <WinnerWheel {...props} />,
    leaderboard: <Leaderboard {...props} />,
    'PDF Slide': <Presentations {...props} />,
    talkingTiles: <TalkingTiles {...props} />,
    quiz: <Quiz {...props} isResult={false} />,
    fantasticFans: <FantasticFans {...props} />,
    map: <Map {...props} mapData={props.data} />,
    credits: <Credits streamId={props?.streamId} currentRosFeature={props?.currentRosFeature} setShowNotification={props?.setShowNotification} />,
    blankScreen: <div className='w-full h-full' />,
    transientThought: <TransientThought {...props} />,
    freeForm: <Poll {...props} pollData={props.data} />,
    textTrack: <TextTrack {...props} isResult={false} />,
    ratingPolls: <RatingPolls {...props} isResult={false} />,
    pollWithOptions: <Poll {...props} pollData={props.data} />,
    multipleChoice: <MultipleChoice {...props} isResult={false} />,
    wordCloud: <Wordcloud {...props} wordCloudData={props.data} />,
    linkLibrary: <LinkLibrary {...props} linkData={[]} totalLinks={0} />,
    emojisEverywhere: <EmojisEverywhere {...props} emojisEverywhereData={props.data} />,
    'Quick Questions': <QuickQuestions {...props} questionData={[]} totalQuestions={0} />,
  };

  if (props?.currentRosFeature) {
    return (
      <InteractionErrorBoundary
        handlePlayIcon={props?.handlePlayIcon}
      >
        <Modal
          size="xl"
          className='h-[80dvh]'
          theme={props?.layoutTheme === 'dark' ? 'dark' : 'light'}
          isOpen={props?.openTrackModal !== '' && props?.openTrackModal !== undefined}
          onClose={() => {
            props?.setOpenTrackModal('');
          }}
          disableOuterScroll
          scrollBehavior='inside'
          placement='center'
        >
          <TrackInteractionsModal {...props} />
        </Modal>
        {interactionComponent[props?.currentRosFeature?.type]}
      </InteractionErrorBoundary>
    );
  }
  return null;
};
